/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../types/types';
import ThemeIconProvider from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Map ZoomIn Icon component.
 */
export const MapZoomInIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <ThemeIconProvider name='MapZoomInIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
        <path d='M5 12h14.15M12 19.15V5'
          stroke={iconColor}
          strokeWidth={1.5}
          strokeMiterlimit={10}
          strokeLinecap='round' />
      </svg>
    )} />
  );
};
